import type { ZodError } from 'zod';

import type { ValidationIssue } from '@/types/api.types';

export type FieldErrors = Record<string, string>;

/** Turns a ZodError into a `{ fieldName: message }` map for form rendering. */
export function toFieldErrors(error: ZodError): FieldErrors {
  const errors: FieldErrors = {};
  for (const issue of error.issues) {
    const key = issue.path.join('.');
    errors[key] ??= issue.message;
  }
  return errors;
}

/** Same shape, but from the backend's `error.details` array. */
export function issuesToFieldErrors(issues: ValidationIssue[]): FieldErrors {
  const errors: FieldErrors = {};
  for (const issue of issues) {
    // The API prefixes paths with the request part, e.g. `body.email`.
    const key = issue.path.replace(/^(body|query|params)\./, '');
    errors[key] ??= issue.message;
  }
  return errors;
}
